<template>
  <layout />
</template>

<script>
import layout from './components/layouts/Layout.vue'; // Your current layout

export default {
  name: "VueCRUD",
  components: {
    layout,
  },

};
</script>